<!-- begin:: Error -->
<div
  class="error error-5 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
  style="background-image: url(./assets/media/error/bg5.jpg); height: 100vh"
>
  <!--begin::Content-->
  <div
    class="container d-flex flex-row-fluid flex-column justify-content-md-center p-12"
  >
    <h1 class="font-weight-boldest text-info">Oops!</h1>
    <p class="font-weight-boldest display-4">Not Found...</p>
    <p class="font-size-h3">
      You can back or use our Help Center.
      <br />
      <button (click)="goback()" class="btn btn-danger mt-10" color="warn">
        Go Back
      </button>
    </p>
  </div>
  <!--end::Content-->
</div>
<!-- end:: Error -->
